"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require('react');
const { Link } = require("gatsby");
const Header = ({ siteTitle }) => (React.createElement("header", { style: {
        borderBottom: `1px solid #555`,
        marginBottom: `1.45rem`,
        textAlign: 'right'
    } },
    React.createElement("div", { style: {
            margin: `0 auto`,
            maxWidth: 960,
            padding: `0.75rem 1.0875rem`,
        } },
        React.createElement("h1", { style: { marginTop: 0, marginBottom: '-1rem' } },
            React.createElement(Link, { to: "/", style: {
                    color: `#555`,
                    textDecoration: `none`,
                } }, siteTitle)))));
exports.default = Header;
